import { render, staticRenderFns } from "./AddRecipientGroup.vue?vue&type=template&id=05c51238"
import script from "./AddRecipientGroup.vue?vue&type=script&lang=js"
export * from "./AddRecipientGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports